import { useEffect, useMemo, useState } from "react";
import { Container } from "@mui/material";
import { getBrand, getCountry } from "api";
import { Cart } from "components/Cart/Cart";
import useStyles from './Mobile.styles';
import { useMobileContext } from "context/mobile/mobileContext";
import { ProductsByCategory, Category, HomePage } from "./pages/Home";
import { DesktopMobileHeader } from "components/Header/DesktopMobileHeader";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import { PreviewPage } from "./pages/Preview";
import { SuccessPage } from "./pages/Success";
import TagManager from "react-gtm-module";

// TODO:- use CSS for this
function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function formatCategoryName(string: string) {
  return capitalizeFirstLetter(string);
}

interface MobileProps {
  user: any;
}

export function Mobile({ user }: MobileProps) {
  const classes = useStyles();
  const location = useLocation();
  const [isMobileApp] = useState(!!(window as any)?.mapp);
  const { brand, setBrand, country, setCountry } = useMobileContext();

  const [isLoading, setIsLoading] = useState(true);
  const [productsByCategory, setProductsByCategory] = useState<ProductsByCategory>({});
  const [categories, setCategories] = useState<Category[]>();
  const currentStore =  useMemo(() => { return (window.mapp as any)?.userInfo?.currentStore }, []);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: location.pathname + location.search,
      },
    })
  }, [location.pathname, location.search]);

  useEffect(() => {
    const { countryIsoCode, primaryBrand } = currentStore || { countryIsoCode: 'KWT', primaryBrand: 'PH' };
    getCountry({ id: countryIsoCode, brandId: primaryBrand }).then(setCountry);
    getBrand(primaryBrand).then(setBrand);
  }, [setCountry, setBrand, currentStore]);

  useEffect(() => {
    const products = country?.products || [];
    const productsByCategory = products.reduce((acc, product) => {
      const { category, heading, subHeading } = product;

      if (!acc[category]) acc[category] = [];
      acc[category].push({
        ...product,
        searchField: `${category} ${heading} ${subHeading}`.toLowerCase(),
      });

      return acc;
    }, {} as ProductsByCategory);

    setProductsByCategory(productsByCategory);
    setCategories(Object.keys(productsByCategory).map((category) => ({
      id: category,
      value: formatCategoryName(category),
      href: `#${category}`,
    })));
    setIsLoading(false);
  }, [country]);

  return (
    <Container className={classes.container}>
      <Outlet />
      <Routes>
        <Route path="preview" element={<PreviewPage />}></Route>
        <Route path="success" element={<SuccessPage />}></Route>
        <Route path="*" element={(
          <>
            {(!isMobileApp || !currentStore || (!isLoading && !categories?.length)) && (
              <DesktopMobileHeader
                activeCountry={country}
                setCountry={setCountry}
                activeBrand={brand}
                setBrand={setBrand}
              />
            )}
            <HomePage {...{ isLoading, categories, productsByCategory }} />
            <Cart />
          </>
        )} />
      </Routes>
    </Container>
  );
}
